module.exports = __webpack_public_path__ + "static/media/behaviourf1829d18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/behaviour.svg
// module id = 1317
// module chunks = 0